import axios from "@axios";

// Field a typed value falls back to when the user did not pick one.
export const UNIT_SEARCH_DEFAULT_FIELD = "description";

/**
 * Fields offered by the faceted search of the units view. Each `value` travels
 * verbatim as a query parameter, so it must be a column the advanced_search of
 * /v1/unit accepts.
 */
export const UNIT_SEARCH_OPTIONS = [
  {
    label: "Nombre",
    value: "description",
    isArray: false,
  },
  {
    label: "Categoría",
    value: "category_ss",
    isArray: false,
  },
  {
    label: "Rems",
    value: "rems",
    isArray: false,
  },
  {
    label: "SIRH",
    value: "sirh",
    isArray: false,
  },
  {
    label: "Dirección",
    value: "address_1",
    isArray: false,
  },
  {
    label: "C.P.",
    value: "postal_code",
    isArray: false,
  },
  {
    label: "ID SEPROBAN",
    value: "id_seproban",
    isArray: false,
  },
  {
    label: "IP VPN",
    value: "ip_vpn",
    isArray: false,
  },
];

// The relations the units table loads, so a unit opened from the search renders
// the same sections as one opened from a table row.
const UNIT_SEARCH_RELATIONS = [
  "router",
  "router.tenant",
  "country",
  "region",
  "municipality",
  "cameras",
  "category",
  "additional_info",
  "lastRiskEvaluation",
];

/**
 * Resolve the first unit matching the faceted filters. The sort defaults to the
 * one the units table starts with, so the resolved unit is the first row that
 * same search would list.
 *
 * @param {Object} filters faceted-search payload ({field: value})
 * @param {Object} [options]
 * @param {String} [options.sortBy]
 * @param {Boolean} [options.sortDesc]
 * @returns {Promise<Object|null>} the unit, or null when nothing matches
 */
export async function fetchFirstUnitMatch(
  filters,
  { sortBy = "id", sortDesc = true } = {}
) {
  const { data } = await axios.get("v1/unit", {
    params: {
      ...filters,
      advanced_search: true,
      max: 1,
      "page[n]": 1,
      sortBy,
      sortDesc,
      with: UNIT_SEARCH_RELATIONS,
    },
  });

  const [unit] = data?.data || [];

  return unit || null;
}
